module.exports = __webpack_public_path__ + "img/weight-scale.017453a3.svg";